<script setup lang="ts">
import type { RichTextData } from '~/utils/crystallize/component-schemas'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'

const { footnotes } = defineProps<{
  footnotes: RichTextData | null | undefined
}>()

const nonEmptyFootnotes = computed(() => footnotes?.filter(blockHasContent) ?? [])
</script>

<template>
  <details v-if="nonEmptyFootnotes.length" class="bg-carbon-50 [--content-offset-y:theme(spacing.m)] rounded-lg">
    <summary class="p-m flex items-center justify-between">
      <h2 class="title-s">
        Fotnoter
      </h2>
      <Icon :icon="faChevronDown" size="sm" />
    </summary>

    <div class="p-m">
      <CrystallizeRichText v-for="(block, i) in nonEmptyFootnotes" :key="i" :block="block" />
    </div>
  </details>
</template>
